import { urls } from '../config'
import { organizationJsonLd } from '../lib/structuredData'
import { CallToAction } from '../sections/CallToAction'
import { Footer } from '../sections/Footer'
import { Header } from '../sections/Header'
import { JobsHero } from '../sections/JobsHero'
import { JobsVacancies } from '../sections/JobsVacancies'
import { SEO } from '../sections/SEO'
import { Team } from '../sections/Team'

export const Jobs = () => {
  return (
    <>
      <SEO page="jobs" path="/jobs" jsonLd={organizationJsonLd} />
      <Header />
      <main>
        <JobsHero />
        <JobsVacancies />
        <Team showCheckoutVacancies={false} vacanciesUrl={urls.mailto} />
        <CallToAction />
      </main>
      <Footer />
    </>
  )
}
